import { Fancybox } from '@fancyapps/ui';
import Splide from '@splidejs/splide';
import Odometer from 'odometer';
import AOS from 'aos';

import SimpleParallax from 'simple-parallax-js/dist/vanilla/simpleParallaxVanilla.es';

(function () {


  // Simple Parallax
  const parallaxEls = document.querySelectorAll('[data-parallax]');
  if (parallaxEls.length) {
    new SimpleParallax(parallaxEls, {
      scale: 1.15,
      delay: 0,
      overflow: false
    });
  }

  // AOS
  AOS.init({
    duration: 900,
    easing: 'ease-out-cubic',
    once: true,
    offset:0
  });

  // Odometer
  var elements = document.querySelectorAll('.js-odometer');
  //if (!elements.length) return;
  var observer = new IntersectionObserver(function (entries, obs) {

    entries.forEach(function (entry) {

      if (!entry.isIntersecting) return;

      var el = entry.target;
      var value = el.getAttribute('data-count');

      el.innerHTML = 0;

      var od = new Odometer({
        el: el,
        value: 0,
        duration: 2000
      });

      od.update(value);
      obs.unobserve(el);
    });

  }, {
    threshold: 0.6
  });

  elements.forEach(function (el) {
    observer.observe(el);
  });

   // Fancybox
  Fancybox.bind('[data-fancybox]', {
    dragToClose: false,
    closeButton: false,
    placeFocusBack: false
  });

  // Splide
  var slider = document.querySelector('.c-slider-home__carousel');
  // if (!slider) return;
  if (slider) {
    var slides = slider.querySelectorAll('.splide__slide');
    var hasMultipleSlides = slides.length > 1;

    new Splide(slider, {
      type: 'fade',
      rewind: true,
      arrows: false,
      pagination: hasMultipleSlides,
      autoplay: hasMultipleSlides,
      interval: 7500,
      speed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: hasMultipleSlides
    }).mount();
  }


  const params = new URLSearchParams(window.location.search);
  if (params.get('popup') === 'presupuesto') {
    Fancybox.show(
      [
        {
          src: '#popup-form-presupuesto',
          type: 'inline'
        }
      ],
      {
        dragToClose: false,
        closeButton: false,
        placeFocusBack: false,
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: []
          }
        }
      }
    );
  }

})();


// Scripts
import './modules/scripts';





